import { render, staticRenderFns } from "./AdminProviderDialog.vue?vue&type=template&id=81046790"
import script from "./AdminProviderDialog.vue?vue&type=script&lang=js"
export * from "./AdminProviderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports